import { SxProps, Theme } from '@mui/material'

import { DISABLED_CONTAINER_OPACITY } from 'providers/material-ui/theme/constants'

export const HB_SECTION_KEYS = ['hb_format', 'hb_bidder'] as const
export const OPACITY_BOX_STYLE: SxProps<Theme> = {
  cursor: 'default',
  opacity: DISABLED_CONTAINER_OPACITY,
} as const
